import { render, staticRenderFns } from "./NeoparentTranslationLanguage.vue?vue&type=template&id=791ca609&scoped=true"
import script from "./NeoparentTranslationLanguage.vue?vue&type=script&lang=js"
export * from "./NeoparentTranslationLanguage.vue?vue&type=script&lang=js"
import style0 from "./NeoparentTranslationLanguage.vue?vue&type=style&index=0&id=791ca609&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ca609",
  null
  
)

export default component.exports